import { Link } from "react-router-dom";
import { events } from "@/mocks/events";
import SectionHeading from "@/components/base/SectionHeading";
import StatusBadge from "@/components/base/StatusBadge";
import HeatMeter from "@/components/base/HeatMeter";

export default function HotEventsSection() {
  const sorted = [...events].sort((a, b) => b.heat - a.heat);
  const featured = sorted[0];
  const rest = sorted.slice(1, 5);

  return (
    <section id="hot-events" className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-50">
      <div className="w-full">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <SectionHeading
            kicker="今日最热"
            title="当下讨论度最高的事件"
            desc="按热度排序，点进任意事件即可查看完整时间线与前因后果。"
          />
          <Link
            to="/events"
            className="inline-flex items-center gap-1.5 whitespace-nowrap text-sm font-semibold text-primary-600 transition-colors duration-200 hover:text-primary-700 cursor-pointer"
          >
            查看全部事件
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line" />
            </span>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-5">
          <article className="lg:col-span-7 group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors duration-300 hover:border-primary-300">
            <Link to={`/event/${featured.id}`} className="block cursor-pointer">
              <div className="relative w-full h-60 md:h-72 overflow-hidden bg-background-200">
                <img
                  src={featured.cover}
                  alt={`${featured.title} 事件封面`}
                  title={`${featured.title} - 热门吃瓜时间线`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent" />
                <div className="absolute left-4 top-4 flex items-center gap-2">
                  <span className="rounded-full bg-primary-500 px-3 py-1 text-xs font-semibold text-background-50">
                    热度第一
                  </span>
                  <StatusBadge status={featured.status} className="bg-background-50/95 backdrop-blur" />
                </div>
                <div className="absolute bottom-4 left-4 right-4">
                  <h3 className="font-heading text-lg md:text-2xl font-bold leading-snug text-background-50">
                    {featured.title}
                  </h3>
                </div>
              </div>
            </Link>
            <div className="p-5 md:p-6">
              <p className="text-sm leading-relaxed text-foreground-600">{featured.summary}</p>

              <div className="mt-5 border-l-2 border-primary-200 pl-4">
                <h4 className="text-xs font-semibold tracking-widest text-foreground-500 uppercase">
                  时间线速览
                </h4>
                <ul className="mt-3 space-y-2.5">
                  {featured.timeline.slice(0, 3).map((node) => (
                    <li key={node.title} className="flex gap-3 text-sm">
                      <span className="w-20 shrink-0 text-xs text-foreground-400 pt-0.5">
                        {node.date}
                      </span>
                      <span className="text-foreground-700 leading-relaxed">{node.title}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="mt-5 flex flex-wrap items-center justify-between gap-3">
                <HeatMeter heat={featured.heat} />
                <Link
                  to={`/event/${featured.id}`}
                  className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md bg-foreground-950 px-4 py-2 text-sm font-semibold text-background-50 transition-colors duration-200 hover:bg-primary-600 cursor-pointer"
                >
                  看完整复盘
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line" />
                  </span>
                </Link>
              </div>
            </div>
          </article>

          <div className="lg:col-span-5 flex flex-col gap-3">
            {rest.map((event, idx) => (
              <Link
                key={event.id}
                to={`/event/${event.id}`}
                className="flex gap-3 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors duration-200 hover:border-primary-300 hover:bg-background-100 cursor-pointer"
              >
                <div className="relative w-20 h-20 md:w-24 md:h-24 shrink-0 overflow-hidden rounded-md bg-background-200">
                  <img
                    src={event.cover}
                    alt={`${event.title} 事件封面`}
                    title={`${event.title} - 热门吃瓜时间线`}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="flex min-w-0 flex-1 flex-col">
                  <div className="flex items-center gap-2">
                    <span className="inline-flex items-center justify-center rounded-md bg-background-200 px-2 py-0.5 text-xs font-bold text-foreground-700">
                      {idx + 2}
                    </span>
                    <span className="text-xs text-foreground-500 whitespace-nowrap">
                      {event.category}
                    </span>
                  </div>
                  <h3 className="mt-1.5 line-clamp-2 font-heading text-sm font-bold leading-snug text-foreground-950">
                    {event.title}
                  </h3>
                  <div className="mt-auto pt-2">
                    <HeatMeter heat={event.heat} />
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}